<template>
  <RevButton v-if="!error" :disabled="!url" :to="url" variant="secondary">
    {{ ctaLabel }}
  </RevButton>
</template>

<script setup lang="ts">
import { RevButton } from '@ds/components/Button'

import { useEducatorVerificationUrl } from './useEducatorVerificationUrl'

defineProps<{ ctaLabel: string }>()

const { url, error } = useEducatorVerificationUrl()
</script>
